import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="container-page">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            探索<strong>内容分类</strong>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            按分类浏览您感兴趣的内容，快速找到注册教程、功能指南、安全知识和交友技巧。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?cat=${cat.slug}`}
              className="group p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-secondary-300 transition-all duration-300 cursor-pointer flex items-start gap-5"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors duration-300 flex-shrink-0">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5 group-hover:text-secondary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-500">
                  {cat.articleCount} 篇文章
                </span>
              </div>
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-hover:text-secondary-500 transition-colors">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}